import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/user.model';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { OrderService } from 'src/app/services/order/order.service';
import { ReportService } from 'src/app/services/reports/report.service';

@Component({
  selector: 'app-filledorderreport',
  templateUrl: './filledorderreport.component.html',
  styleUrls: ['./filledorderreport.component.css']
})
export class FilledorderreportComponent implements OnDestroy, OnInit {

  data: User;
  dtOptions: any = {};
  dtTrigger = new Subject<any>();

  constructor(private router: Router, private userService: UserService, private reportService: ReportService) {
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.getFilledOrderReport();
    this.dtOptions = {
      //ajax: JSON.stringify(this.data),
      // columns: [{
      //   title: 'ID',
      //   data: 'id'
      // }, {
      //   title: 'First name',
      //   data: 'firstName'
      // }, {
      //   title: 'Last name',
      //   data: 'lastName'
      // }],
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      // Configure the buttons
      buttons: [
        //'columnsToggle',
        //'colvis',
        'copy',
        'print',
        'excel'
        // ,{
        //   text: 'Some button',
        //   key: '1',
        //   action: function (e, dt, node, config) {
        //     alert('Button activated');
        //   }
        // }
      ]
    };

  }

  getFilledOrderReport() {
    this.reportService.getFilledOrderReport().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
        if (!isNullOrUndefined(this.data)) {
          this.dtTrigger.next();
        }
      }
    )
  }

  // onEdit(id : string, name : string, index : number)
  // {
  //   alert(id);
  //   alert(name);
  // }


}
